export const FETCH_NOTIFICATIONS_SUCCESS = 'fetch_notifications_success'
export const FETCH_UNREAD_NOTIFICATIONS_SUCCESS = 'fetch_unread_notifications_success'
export const ADD_NOTIFICATION = 'add_notification'
export const UPDATE_NOTIFICATION = 'update_notification'
export const SET_UNREAD_NOTIFICATION_COUNT = 'set_unread_notification_count'
export const SET_NEW_INSIGHTS = 'set_new_insights'
export const SET_NOTIFICATION_COUNT = 'set_notification_count'
export const READ_NOTIFICATION = 'read_notification'
export const READ_NEW_INSIGHTS = 'read_new_insights'
